import React, { useState, useRef } from 'react';
import { profileService } from '../../components/services/profileServices';
import './avatar-upload.scss';

const AvatarUpload = ({ avatarUrl, onAvatarUpdate, size = 100 }) => {
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    const [imageError, setImageError] = useState(false); // ✅ NUOVO
    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validazioni client-side
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            alert('Formato non supportato. Usa JPG, PNG o WEBP');
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            alert('Il file non deve superare 2MB');
            return;
        }

        // Preview
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreview(reader.result);
            setImageError(false);
        };
        reader.readAsDataURL(file);

        // Upload
        uploadAvatar(file);
    };

    const uploadAvatar = async (file) => {
        setLoading(true);
        const result = await profileService.uploadAvatar(file);
        
        console.log('📥 Upload result:', result);
    
    if (result.success) {
        const newAvatarUrl = result.user?.avatar_url || result.data?.avatar_url;
        
        if (newAvatarUrl) {
            console.log('✅ Avatar URL ricevuto:', newAvatarUrl);
            setImageError(false); // ✅ Reset errore
            if (onAvatarUpdate) {
                onAvatarUpdate(newAvatarUrl);
            }
        }
        setPreview(null);
        } else {
            alert(result.message || 'Errore durante l\'upload');
            setPreview(null);
        }
        setLoading(false);
        setShowMenu(false);
    };

    const handleRemoveAvatar = async () => {
        if (!window.confirm('Sei sicuro di voler rimuovere il tuo avatar?')) return;
        
        setLoading(true);
        const result = await profileService.removeAvatar();
        
        if (result.success) {
            setImageError(false);
            if (onAvatarUpdate) {
                onAvatarUpdate(null);
            }
        } else {
            alert(result.message);
        }
        setLoading(false);
        setShowMenu(false);
    };

     // ✅ Gestisce errore caricamento immagine
    const handleImageError = (e) => {
        console.warn('⚠️ Errore caricamento avatar, passo al default');
        setImageError(true);
        e.target.onerror = null;
    };

    // ✅ Determina cosa mostrare
    const getDisplayImage = () => {
        // 1. Preview durante upload
        if (preview) return preview;
        
        // 2. Se c'è stato un errore, non mostrare nulla (mostra default)
        if (imageError) return null;
        
        // 3. Se c'è un avatar URL, processalo
        if (avatarUrl) {
            const fullUrl = profileService.getAvatarUrl(avatarUrl);
            console.log('🖼️ Displaying avatar:', fullUrl);
            return fullUrl;
        }
        
        // 4. Nessun avatar → default
        return null;
    };

    const displayImage = getDisplayImage();

    return (
        <div className="avatar-upload-wrapper">
            <div 
                className="avatar-container"
                style={{ width: size, height: size }}
                onClick={() => setShowMenu(!showMenu)}
            >
                {loading ? (
                    <div className="avatar-loading">
                        <div className="spinner-small"></div>
                    </div>
                ) : displayImage ? (
                    <img 
                        src={displayImage} 
                        alt="Avatar" 
                        className="avatar-image"
                        onError={handleImageError}
                    />
                ) : (
                    <div className="avatar-placeholder">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                            <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M5 20V19C5 15.13 8.13 12 12 12C15.87 12 19 15.13 19 19V20" stroke="currentColor" strokeWidth="1.5"/>
                        </svg>
                    </div>
                )}
                <div className="avatar-overlay">
                    <span>📷</span>
                </div>
            </div>

            {showMenu && (
                <div className="avatar-menu">
                    <button onClick={() => fileInputRef.current.click()}>
                        📷 Cambia avatar
                    </button>
                    {avatarUrl && (
                        <button className="remove" onClick={handleRemoveAvatar}>
                            🗑️ Rimuovi avatar
                        </button>
                    )}
                </div>
            )}

            <input
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/png,image/jpg,image/webp"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default AvatarUpload;
